import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconFullScreen: React.FC<IconProps> = ({ width = 60, height = 60 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
        >
            <path
                d="M3.18867 7.59844C3.45273 7.59844 3.67617 7.375 3.67617 7.11094V4.36875L9.70898 10.4016C9.81055 10.5031 9.93242 10.5438 10.0543 10.5438C10.1762 10.5438 10.298 10.5031 10.3996 10.4016C10.5824 10.2188 10.5824 9.89375 10.3996 9.71094L4.3668 3.67813H7.10898C7.37305 3.67813 7.59648 3.45469 7.59648 3.19062C7.59648 2.92656 7.37305 2.70312 7.10898 2.70312H3.18867C3.12773 2.70312 3.0668 2.72344 3.00586 2.74375C2.88398 2.78437 2.78242 2.88594 2.7418 3.00781C2.72148 3.06875 2.70117 3.12969 2.70117 3.19062V7.11094C2.70117 7.39531 2.92461 7.59844 3.18867 7.59844Z"
                fill="black"
            />
            <path
                d="M23.2984 3.19062C23.2984 3.12969 23.2781 3.06875 23.2578 3.00781C23.2172 2.88594 23.1156 2.78437 22.9937 2.74375C22.9328 2.72344 22.8719 2.70312 22.8109 2.70312H18.8906C18.6266 2.70312 18.4031 2.92656 18.4031 3.19062C18.4031 3.45469 18.6266 3.67813 18.8906 3.67813H21.6328L15.6 9.71094C15.4172 9.89375 15.4172 10.2188 15.6 10.4016C15.7016 10.5031 15.8234 10.5438 15.9453 10.5438C16.0672 10.5438 16.1891 10.5031 16.2906 10.4016L22.3234 4.36875V7.11094C22.3234 7.375 22.5469 7.59844 22.8109 7.59844C23.075 7.59844 23.2984 7.375 23.2984 7.11094V3.19062Z"
                fill="black"
            />
            <path
                d="M22.9937 23.2598C23.1156 23.2191 23.2172 23.1176 23.2578 22.9957C23.2781 22.9348 23.2984 22.8738 23.2984 22.8129V18.8926C23.2984 18.6285 23.075 18.4051 22.8109 18.4051C22.5469 18.4051 22.3234 18.6285 22.3234 18.8926V21.6348L16.2906 15.602C16.1078 15.4191 15.7828 15.4191 15.6 15.602C15.4172 15.7848 15.4172 16.1098 15.6 16.2926L21.6328 22.3254H18.8906C18.6266 22.3254 18.4031 22.5488 18.4031 22.8129C18.4031 23.077 18.6266 23.3004 18.8906 23.3004H22.8109C22.8719 23.3004 22.9328 23.2801 22.9937 23.2598Z"
                fill="black"
            />
            <path
                d="M3.00586 23.2598C3.0668 23.2801 3.12773 23.3004 3.18867 23.3004H7.10898C7.37305 23.3004 7.59648 23.077 7.59648 22.8129C7.59648 22.5488 7.37305 22.3254 7.10898 22.3254H4.3668L10.3996 16.2926C10.5824 16.1098 10.5824 15.7848 10.3996 15.602C10.2168 15.4191 9.8918 15.4191 9.70898 15.602L3.67617 21.6348V18.8926C3.67617 18.6285 3.45273 18.4051 3.18867 18.4051C2.92461 18.4051 2.70117 18.6285 2.70117 18.8926V22.8129C2.70117 22.8738 2.72148 22.9348 2.7418 22.9957C2.78242 23.1176 2.88398 23.2191 3.00586 23.2598Z"
                fill="black"
            />
        </svg>
    );
};

export default IconFullScreen;
